import * as Campos from '../constantes/Campos.js';

export const OnCampoTorneoChange = (torneo, campo, valor) => {
  switch (campo) {
    case Campos.NuevoTorneo.ANIO: {
      // Por defecto la temporada es igual al año
      return { ...torneo, anio: valor, temporada: valor.toString() };
    }
    case Campos.NuevoTorneo.TEMPORADA: {
      return { ...torneo, temporada: valor };
    }
    case Campos.NuevoTorneo.FECHA_INICIO: {
      const nuevoTorneo = {
        ...torneo,
        anioInicio: valor[0],
        mesInicio: valor[1],
        diaInicio: valor[2],
      };
      if (!nuevoTorneo.anio) {
        nuevoTorneo.anio = nuevoTorneo.anioInicio;
        nuevoTorneo.temporada = nuevoTorneo.anio.toString();
      }
      return nuevoTorneo;
    }
    case Campos.NuevoTorneo.FECHA_FIN: {
      return { ...torneo, fechaFin: valor };
    }
    case Campos.NuevoTorneo.CATEGORIA: {
      return { ...torneo, categoria: valor };
    }
    case Campos.NuevoTorneo.TIPO_TORNEO: {
      // Al cambiar tipo de torneo, limpiar país si ya no es necesario
      const nuevoTorneo = { ...torneo, tipoTorneo: valor };
      if (!valor?.oficialidad?.dePais) {
        nuevoTorneo.pais = null;
      }
      return nuevoTorneo;
    }
    case Campos.NuevoTorneo.PAIS: {
      return { ...torneo, pais: valor };
    }
    case Campos.NuevoTorneo.NOMBRE: {
      return { ...torneo, nombre: valor };
    }
    case Campos.NuevoTorneo.CANTIDAD_PARTICIPANTES: {
      return { ...torneo, cantidadParticipantes: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido para Torneo');
    }
  }
};

export const ValidarTorneo = (torneo) => {
  if (!torneo.anio) {
    return 'Debe ingresar el año';
  }
  if (!torneo.temporada || torneo.temporada.trim() === '') {
    return 'Debe ingresar la temporada';
  }
  if (torneo.temporada.length > 7) {
    return 'La temporada no puede tener más de 7 caracteres';
  }
  if (!torneo.categoria) {
    return 'Debe seleccionar una categoría';
  }
  if (!torneo.tipoTorneo) {
    return 'Debe seleccionar un tipo de torneo';
  }
  if (!torneo.nombre || torneo.nombre.trim() === '') {
    return 'Debe ingresar un nombre';
  }
  if (torneo.nombre.length > 50) {
    return 'El nombre no puede tener más de 50 caracteres';
  }

  // Validar coherencia de fechas inicio/fin
  if (torneo.fechaFin) {
    // Crear fecha de inicio (año, mes, día)
    let fechaInicio = null;
    if (torneo.anioInicio && torneo.mesInicio !== null && torneo.diaInicio !== null) {
      // Fecha completa: año, mes, día
      fechaInicio = new Date(torneo.anioInicio, torneo.mesInicio, torneo.diaInicio);
    } else if (torneo.anioInicio && torneo.mesInicio !== null) {
      // Solo año y mes: usar día 1
      fechaInicio = new Date(torneo.anioInicio, torneo.mesInicio, 1);
    } else if (torneo.anioInicio) {
      // Solo año: usar 1 de enero
      fechaInicio = new Date(torneo.anioInicio, 0, 1);
    }

    if (fechaInicio) {
      const fechaFin = new Date(torneo.fechaFin);
      if (fechaInicio > fechaFin) {
        return 'La fecha de inicio debe ser menor o igual a la fecha de fin';
      }
    }
  }

  // Validar que si el tipo de torneo requiere país, esté seleccionado
  if (torneo.tipoTorneo?.oficialidad?.dePais && !torneo.pais) {
    return 'Debe seleccionar un país para este tipo de torneo';
  }

  return '';
};
